import { render, staticRenderFns } from "./funcionarioHome.vue?vue&type=template&id=4b4b5178&"
import script from "./funcionarioHome.vue?vue&type=script&lang=js&"
export * from "./funcionarioHome.vue?vue&type=script&lang=js&"
import style0 from "./funcionarioHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports